import { makeStyles as muiMakeStyles } from 'tss-react/mui';

export const makeStyles = muiMakeStyles;
